/**
 * Copies URL to clipboard, with an alert as fallback if API not available
 * @param {MouseEvent} event
 */
function handlePopoverCopyUrlButton(event) {
  console.log('in handlePopoverCopyUrlButton');
  const button = event.target.closest('.popover-copy-url-button');
  // if click was on this type of button...
  if (button) {
    event.preventDefault();

    const shareData = {
      title: document.title,
      url: `${location.origin}${location.pathname}${location.hash}`
      // text: document.querySelector("meta[name='description']").getAttribute('content')
    };

    // Use the Clipboard API if it is available
    if (navigator.clipboard) {
      navigator.clipboard.writeText(shareData.url).then(
        () => {
          console.log('Async: Copying to clipboard was successful!');
          showCopiedUrlConfirmationTooltip(button);
        },
        (err) => {
          console.error('Async: Could not copy text: ', err);
        }
      );
    }

    else {
      console.warn(`The Clipboard API is not available. You may need to make sure you are on an https connection on a modern browser.`);
      alert(`The URL is:

${shareData.url}`);
    }
  }
}

function showCopiedUrlConfirmationTooltip(button) {
  const tooltip = button.closest('.popover').querySelector('.url-copy-tooltip');
  tooltip.hidden = false;
  setTimeout(() => {
    tooltip.hidden = true;
  }, 1500);
}

// Handle when the Popover Copy URL button is clicked. Function imported in copyURLButton.js
window.addEventListener('click', handlePopoverCopyUrlButton);

export default handlePopoverCopyUrlButton;
